import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["children", "className", "defaultIsOpen", "id", "isControlled", "isDisabled", "isOpen", "lineClamp", "mode", "onOpenChange", "triggerCloseText", "triggerOpenText", "triggerSize", "width"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { forwardRef, useCallback, useEffect, useState } from 'react';
import { ThemeProvider } from 'styled-components';
import cx from 'classnames';
import { prefix } from '../../tools/settings';
import { Styled } from './ReadMore.styles';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var ReadMore = forwardRef(function (_ref, ref) {
  var _cx;

  var children = _ref.children,
      customClassName = _ref.className,
      _ref$defaultIsOpen = _ref.defaultIsOpen,
      defaultIsOpen = _ref$defaultIsOpen === void 0 ? false : _ref$defaultIsOpen,
      id = _ref.id,
      _ref$isControlled = _ref.isControlled,
      isControlled = _ref$isControlled === void 0 ? false : _ref$isControlled,
      _ref$isDisabled = _ref.isDisabled,
      isDisabled = _ref$isDisabled === void 0 ? false : _ref$isDisabled,
      _ref$isOpen = _ref.isOpen,
      controlledIsOpen = _ref$isOpen === void 0 ? false : _ref$isOpen,
      _ref$lineClamp = _ref.lineClamp,
      lineClamp = _ref$lineClamp === void 0 ? 3 : _ref$lineClamp,
      mode = _ref.mode,
      onOpenChange = _ref.onOpenChange,
      _ref$triggerCloseText = _ref.triggerCloseText,
      triggerCloseText = _ref$triggerCloseText === void 0 ? 'Show less…' : _ref$triggerCloseText,
      _ref$triggerOpenText = _ref.triggerOpenText,
      triggerOpenText = _ref$triggerOpenText === void 0 ? 'Show more…' : _ref$triggerOpenText,
      _ref$triggerSize = _ref.triggerSize,
      triggerSize = _ref$triggerSize === void 0 ? 'medium' : _ref$triggerSize,
      width = _ref.width,
      rest = _objectWithoutProperties(_ref, _excluded);

  var className = cx((_cx = {}, _defineProperty(_cx, "".concat(prefix, "-readmore"), true), _defineProperty(_cx, customClassName, !!customClassName), _cx));
  var wrapperWidth = typeof width === 'number' ? "".concat(width, "px") : width;
  var getIsOpen = useCallback(function () {
    return isControlled ? controlledIsOpen : defaultIsOpen;
  }, [controlledIsOpen, defaultIsOpen, isControlled]);

  var _useState = useState(getIsOpen()),
      _useState2 = _slicedToArray(_useState, 2),
      isOpen = _useState2[0],
      setIsOpen = _useState2[1];

  useEffect(function () {
    setIsOpen(getIsOpen());
  }, [getIsOpen]);
  useEffect(function () {
    onOpenChange && onOpenChange(isOpen);
  }, [isOpen, onOpenChange]);
  return _jsx(ThemeProvider, {
    theme: {
      mode: mode
    },
    children: _jsxs(Styled.Root, _objectSpread(_objectSpread({
      ref: ref,
      className: className,
      "data-state": isOpen ? 'open' : 'closed',
      wrapperWidth: wrapperWidth
    }, rest), {}, {
      children: [_jsx(Styled.Content, {
        "data-state": isOpen ? 'open' : 'closed',
        lineClamp: lineClamp,
        isOpen: isOpen,
        children: children
      }), !isControlled && _jsx(Styled.Trigger, {
        "aria-expanded": isOpen ? 'true' : 'false',
        "data-state": isOpen ? 'open' : 'closed',
        isDisabled: isDisabled,
        role: "button",
        onClick: function onClick() {
          return setIsOpen(!isOpen);
        },
        triggerSize: triggerSize,
        children: isOpen ? triggerCloseText : triggerOpenText
      })]
    }))
  });
});
ReadMore.displayName = 'ReadMore';
export default ReadMore;